'use client'
import { createCn, isNullable } from 'shared-utils'
import { GrandProse, GrandSection, ParsedHtml } from 'ui'
import { type FC, useMemo } from 'react'
import type { AiGeneratedHtmlWidgetType, StorefrontWidget } from 'ecosystem'
import { type WidgetImplementation } from '../registry/typings'
import { JsonLd } from '../../seo/components/JsonLd'
import { extractJsonLd } from '../../seo/jsonld/embedded'

const cn = createCn('ai-generated-html')

const WIDGET_CN = {
  SECTION: cn('article'),
  SECTION_CONTAINER: cn('section-container'),
  CONTENT: cn('content')
}

type AiGeneratedHtmlWidgetProps = WidgetImplementation<StorefrontWidget<AiGeneratedHtmlWidgetType>>

export const AiGeneratedHtmlWidget: FC<AiGeneratedHtmlWidgetProps> = ({
  widgetId,
  widget: {
    widget: { content, isWrapped }
  }
}) => {
  const hasCustomStyles = content?.includes('<style')
  const jsonLd = useMemo(() => extractJsonLd(content), [content])

  const renderContent = () => (
    <GrandProse
      as="article"
      className={WIDGET_CN.CONTENT}
      w="100%"
      fontSize="md"
      rawStyles={hasCustomStyles}
    >
      <JsonLd data={jsonLd} />
      <ParsedHtml html={content || ''} />
    </GrandProse>
  )

  // if widget was created before implementing isWrapped the value = undefined and component was intended to be wrapped
  if (!isNullable(isWrapped) && !isWrapped) {
    return renderContent()
  }

  return (
    <GrandSection
      className={WIDGET_CN.SECTION}
      contentContainerProps={{
        className: WIDGET_CN.SECTION_CONTAINER
      }}
      sectionId={widgetId}
    >
      {renderContent()}
    </GrandSection>
  )
}
